var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 18.0312L13.1562 6.65625C12.875 6.21875 12.4375 6 12 6C11.5312 6 11.0938 6.21875 10.8125 6.65625L4.125 18.0312C3.65625 18.9062 4.28125 20 5.3125 20H18.6562C19.6875 20 20.3125 18.9062 19.8125 18.0312ZM5.625 18.5L11.9688 7.65625L18.3438 18.5H5.625ZM12 15.5625C11.4375 15.5625 11 16 11 16.5312C11 17.0625 11.4375 17.5 12 17.5C12.5312 17.5 12.9688 17.0625 12.9688 16.5312C12.9688 16 12.5312 15.5625 12 15.5625ZM11.25 10.75V13.75C11.25 14.1875 11.5625 14.5 12 14.5C12.4062 14.5 12.75 14.1875 12.75 13.75V10.75C12.75 10.3438 12.4062 10 12 10C11.5625 10 11.25 10.3438 11.25 10.75Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.8e2be5959a722c34c97479881481b891.svg";
export { ForwardRef as ReactComponent };